export const daysOfWeek: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
  'Sunday'];

export const monthFullNames: string[] = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];

// eslint-disable-next-line no-shadow
export enum WeatherCondition {
  // eslint-disable-next-line no-unused-vars
  SUNNY = 'sunny', CLOUDY = 'cloudy', CLEAR_CLOUDY = 'clear_cloudy',
  // eslint-disable-next-line no-unused-vars
  PARTLY_CLOUDY = 'partly_cloudy', MOSTLY_CLOUDY = 'mostly_cloudy', SHOWERS = 'showers',
  // eslint-disable-next-line no-unused-vars
  DRIZZLE = 'drizzle', WINDY = 'windy', HAIL = 'hail', SLEET = 'sleet', SNOW = 'snow',
  // eslint-disable-next-line no-unused-vars
  SNOW_FLURRIES = 'snow_flurries', ISOLATED_THUNDERSTORMS = 'isolated_thunderstorms',
  // eslint-disable-next-line no-unused-vars
  THUNDERSTORMS = 'thunderstorms', TORNADO = 'tornado',
}

export type WeatherDataItem = {
  date: string,
  temperature?: number,
  condition: WeatherCondition,
}

export const DEFAULT_WEATHER_DATA: WeatherDataItem[] = [
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.SUNNY,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.CLEAR_CLOUDY,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.PARTLY_CLOUDY,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.MOSTLY_CLOUDY,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.SHOWERS,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.DRIZZLE,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.SNOW,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.SNOW_FLURRIES,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.WINDY,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.ISOLATED_THUNDERSTORMS,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.THUNDERSTORMS,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.HAIL,
  },
  {
    date: new Date().toISOString(),
    temperature: 10,
    condition: WeatherCondition.SLEET,
  },
];

// eslint-disable-next-line no-unused-vars, no-shadow
export enum WeatherWidgetSize { SINGLE, MEDIUM, LARGE }
